import axios from "../../service/index";
import React, { Component } from "react";
import { Input, Button, Divider, Table, Pagination, Modal, Form, message, Switch } from "antd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "./payClass.less";
const FormItem = Form.Item;

class PayClass extends Component {
  state = {
    columns: [
      {
        title: "小程序名称",
        dataIndex: "name",
        align: "left",
        key: "name",
      },
      {
        title: "AppID",
        dataIndex: "appid",
        align: "left",
        key: "appid",
      },
      {
        title: "创建人",
        dataIndex: "admin",
        align: "left",
        key: "admin",
      },
      {
        title: "创建时间",
        dataIndex: "createTime",
        align: "left",
        key: "createTime",
      },
      {
        title: "是否手机号授权",
        dataIndex: "status",
        key: "status",
        align: "center",
        render: (record, text) => {
          return (
            <div>
              <Switch
                checked={text.phoneAuthChecked}
                key={text.phoneAuthChecked === true ? true : false}
                onChange={(checked) => {
                  this.topping(text, checked);
                }}
              />
            </div>
          );
        },
      },
      {
        title: "操作",
        align: "center",
        render: (row) => {
          return (
            <div className="all-btn">
              <Button
                type="link"
                onClick={() => {
                  this.handleKnow("edit", row);
                }}>
                编辑
              </Button>
              <Button
                type="link"
                className="red-color"
                onClick={() => {
                  Modal.confirm({
                    title: "删除",
                    okText: "确认",
                    cancelText: "取消",
                    content: "删除后将不可恢复，请谨慎操作！确定要删除吗？",
                    onOk: () => {
                      this.delStage(row.id);
                    },
                  });
                }}>
                删除
              </Button>
            </div>
          );
        },
      },
    ],
    dataSource: [],
    total: 0,
    pageNum: 1,
    size: 10,
    appid: "", // 小程序appid
    name: "", // 小程序名称
    optionList: [],
    detailObj: {},
    showKnowName: false,
    typeQ: "add",
  };

  componentDidMount() {
    this.InitCourse();
    this.InitClassHandle();
  }

  InitCourse() {
    axios.get("paycourse/manager").then((res) => {
      if (res.data.code === "200") {
        this.setState({ optionList: res.data.data });
      }
    });
  }

  // 重置
  ClearKnow() {
    this.setState({ name: "", appid: "" }, () => {
      this.InitClassHandle();
    });
  }

  // 查询列表
  InitClassHandle() {
    let { pageNum, size, name, appid } = this.state;
    axios.post("miniprogram/pageList", { name, pageSize: size, pageNum, appid }).then((res) => {
      if (res.data.code === "200") {
        let data = res.data.data;
        console.log(data);
        this.setState({ total: data.total, dataSource: data.list });
      }
    });
  }

  pageChange = (current) => {
    this.setState({ pageNum: current }, () => {
      this.InitClassHandle();
    });
  };

  sizeChange = (current, size) => {
    this.setState({ size }, () => {
      this.InitClassHandle();
    });
  };

  topping = (text, checked) => {
    Modal.confirm({
      title: `${checked === true ? "开启手机号授权" : "关闭手机号授权"}`,
      okText: "确定",
      cancelText: "取消",
      content: (
        <div>
          <p>{checked === true ? "授权功能开启后，用户在使用小程序时需要完成手机号授权，确定要开启吗？" : "授权功能关闭后，用户在使用小程序时无需授权手机号，确定要关闭吗？"}</p>
        </div>
      ),
      onOk: () => {
        this.isRelease(text.id, checked, "ok");
      },
      onCancel: () => {
        let arr = this.state.dataSource;
        this.setState({
          dataSource: arr,
        });
      },
    });
  };

  isRelease = (id, checked, type) => {
    if (type === "cancel") {
      console.log("取消");
      this.InitClassHandle();
    } else {
      const params = {
        id,
        status: checked ? 1 : 0,
        configSwitch: 1,
      };
      axios.post("miniprogram/config", params).then((res) => {
        if (res.data.code === "200") {
          message.success(`${checked === true ? "开启成功" : "关闭成功"}`);
          this.InitClassHandle();
          Modal.destroyAll();
        } else {
          message.error(res.data.msg);
        }
      });
    }
  };

  // 新增/编辑
  handleKnow = (type, obj) => {
    this.setState({ typeQ: type, detailObj: obj, showKnowName: true }, () => {
      if (type === "edit") {
        this.props.form.setFieldsValue({});
      }
    });
  };

  // 删除
  delStage(id) {
    axios.get(`miniprogram/delete/${id}`).then((res) => {
      if (res.data.code !== "200") return message.error(res.data.msg);
      message.success("删除成功");
      this.InitClassHandle();
    });
  }

  submitOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let { typeQ, detailObj } = this.state;
        let params = {
          name: values.name,
          appid: values.appid,
        };
        if (typeQ === "edit") {
          params.id = detailObj.id;
        } else {
          delete params.id;
        }
        let url = typeQ === "add" ? "miniprogram/add" : "miniprogram/update";
        axios.post(url, params).then((res) => {
          if (res.data.code !== "200") return message.error(res.data.msg);
          message.success(`${typeQ === "add" ? "新增" : "编辑"}成功`);
          this.setState({ showKnowName: false, detailObj: {} });
          this.props.form.resetFields();
          this.InitClassHandle();
        });
      }
    });
  };

  cancelForm = () => {
    this.props.form.resetFields();
    this.setState({ showKnowName: false, detailObj: {} });
  };

  render() {
    let { dataSource, columns, total, pageNum, typeQ, showKnowName, detailObj } = this.state;
    const { getFieldDecorator } = this.props.form;
    return (
      <div>
        <span className="header-name">小程序管理</span>
        <Divider />
        <div className="search-center">
          <Input
            placeholder="请输入小程序名称"
            value={this.state.name}
            onChange={(e) => {
              this.setState({ name: e.target.value });
            }}
          />
          <Input
            placeholder="请输入AppID"
            value={this.state.appid}
            onChange={(e) => {
              this.setState({ appid: e.target.value });
            }}
          />
          <Button
            className="my-button-primary"
            type="primary"
            onClick={() => {
              this.InitClassHandle();
            }}>
            搜索
          </Button>
          <Button
            className="zip-left"
            onClick={() => {
              this.ClearKnow();
            }}>
            重置
          </Button>
          <Button
            className="my-button-primary rig-btn"
            type="primary"
            onClick={() => {
              this.handleKnow("add", {});
            }}>
            添加小程序
          </Button>
        </div>
        <div>
          <DndProvider backend={HTML5Backend}>
            <Table ref="myTable" dataSource={dataSource} columns={columns} pagination={false} rowKey={(record) => record.id} />
            <Pagination
              className="table-pagination"
              total={total}
              current={pageNum}
              showSizeChanger
              showQuickJumper
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={this.pageChange}
              onShowSizeChange={this.sizeChange}
            />
          </DndProvider>
          <Modal title={`${typeQ === "add" ? "添加" : "编辑"}小程序`} width="600px" className="pay-modal" visible={showKnowName} onOk={this.submitOk} onCancel={this.cancelForm}>
            <Form labelCol={{ span: 4 }} wrapperCol={{ span: 18 }} onSubmit={this.submitOk}>
              <FormItem label="小程序名称" name="name">
                {getFieldDecorator("name", {
                  rules: [
                    { required: true, message: "请输入小程序名称" },
                    { max: 50, message: "最多输入20个字!" },
                  ],
                  initialValue: typeQ === "edit" ? detailObj.name : "",
                })(<Input showcount="true" maxLength={20} />)}
              </FormItem>
              <FormItem label="AppID" name="appid">
                {getFieldDecorator("appid", {
                  rules: [{ required: true, message: "请输入AppID" }],
                  initialValue: typeQ === "edit" ? detailObj.appid : "",
                })(<Input placeholder="请输入AppID" />)}
              </FormItem>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }
}
export default Form.create()(PayClass);
